import { render, staticRenderFns } from "./AutorizacaoForm.vue?vue&type=template&id=410548cb"
import script from "./AutorizacaoForm.vue?vue&type=script&lang=js"
export * from "./AutorizacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports